import { Component, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
    selector: 'app-lios-navbar',
    templateUrl: './lios-navbar.component.html',
    styleUrls: ['./lios-navbar.component.scss'],
    standalone: false
})
export class LiosNavbarComponent implements OnInit {
	navlinks = this.constants.navLinkItems;
	rolesArray = [];
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;
	highlightHome = false;
  	selected = new FormControl();
  	currentIndex: any = 0;
	constructor(private readonly constants: Constants, private readonly groupIStateService : GroupIStateService, private readonly versionCheckService: VersionCheckService) { }

	ngOnInit() {
		this.subscription = this.groupIStateService.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if(roles?.length) {
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
		this.selected.setValue(1);
        this.toggler('planning');
		this.versionCheckService.initVersionCheck();
	}

	ngOnDestroy(): void { // NOSONAR
		this.subscription.unsubscribe();
	}
	
	onTabClick(index: number) { // NOSONAR
		localStorage.setItem('currentIndex', index.toString());
	}

	navigate(url: any) { // NOSONAR
		const _url = environment.LOGOUT_REDIRECT_URL + url;
		console.log("_url_ ", _url)
		window.location.href = _url;
	}

	navigateExternalUrl(url: any) { // NOSONAR
		window.location.href = url;
	}

	navigateExternalUrlNewWin(url: any) { // NOSONAR
		window.open(url);
	}

	toggler(pageHeader: string): void { // NOSONAR
		if ( pageHeader.includes('home') || pageHeader == '' || pageHeader == '#' ) { // NOSONAR
			this.highlightHome = true;
		} else {
			this.highlightHome = false;
		}
	}
}
